import { Component, computed, inject, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AnnounceComponent } from 'src/app/pages/event/components/announce/announce.component';
import { shareShoutout } from 'src/app/helpers/shareShoutoutLink';
import { EventStoreService } from 'src/app/services/stores/event.store.service';
import { ShoutoutsStoreService } from 'src/app/services/stores/shoutouts.store.service';
import { EventBalanceComponent } from '../event-balance/event-balance.component';
import { EventCounterStoreService } from 'src/app/services/stores/event-counter.store.service';
import { EventPaymentEnum } from 'src/app/models/event.model';
import { AnnouncerModeService } from 'src/app/services/announcer-mode.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-event-header',
  templateUrl: './event-header.component.html',
  styleUrl: './event-header.component.scss',
  standalone: false,
})
export class EventHeaderComponent {
  private _shoutoutsStoreService: ShoutoutsStoreService = inject(
    ShoutoutsStoreService,
  );
  private _eventCounterStoreService = inject(EventCounterStoreService);
  protected eventStoreService = inject(EventStoreService);
  protected announcerMode: AnnouncerModeService = inject(AnnouncerModeService);
  protected auth: AuthService = inject(AuthService);
  protected shoutoutsToAnnounceCount: Signal<number> = computed(
    () => this._shoutoutsStoreService.shoutouts()?.length || 0,
  );
  protected dialog: MatDialog = inject(MatDialog);
  protected EventPaymentEnum: typeof EventPaymentEnum = EventPaymentEnum;

  startAnnouncing() {
    this.dialog.open(AnnounceComponent, {
      width: '600px',
      data: this._shoutoutsStoreService.shoutouts,
    });
  }

  viewBalance() {
    this.dialog.open(EventBalanceComponent, {
      width: '200px',
      data: this._eventCounterStoreService.eventCounter,
    });
  }

  shareShoutoutCreateLink(): void {
    shareShoutout(this.eventStoreService.event()!);
  }

  enterAnnouncerMode(): void {
    const eventId = this.eventStoreService.event()?.id;
    if (eventId) {
      this.announcerMode.enterAnnouncerMode(eventId);
    }
  }
}
